import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';

function DataSnackbar({ selectedFeatureData }) {

    const [relevantData, setRelevantData] = useState({"type": "", "name": "", "params": {}});

    // This function returns a grade based on the decay constant
    const getDecayConstantGrade = (decayConstant) => {
        if (decayConstant < -0.26 ) {
            return 'Fastest'; // Fastest
        } else if (decayConstant < -0.22) {
            return 'Fast'; // Fast
        } else if (decayConstant < -0.18) {
            return 'Good'; // Good
        } else if (decayConstant < -0.12 ) {
            return 'Average'; // Average
        } else if (decayConstant < -0.10 ) {
            return 'Below Average'; // Below Average
        } else if (decayConstant < -0.06 ) {
            return 'Slow'; // Slow
        } else if (decayConstant < 0 ) {
            return 'Very Slow'; // Very Slow
        } else {
            return 'Unknown';
        }
    };

    // This sets the relevant data when the selected feature changes
    useEffect(() => {
        if (!selectedFeatureData) {
            return;
        }
        if (selectedFeatureData.IMPERV) {
            setRelevantData({
                "type": "Subcatchment",
                "name": selectedFeatureData.NAME,
                "params" : {
                    "Area": `${selectedFeatureData.AREA} acres`,
                    "Percent Impervious": `${selectedFeatureData.IMPERV}%`,
                    "Elevation": `${selectedFeatureData.WTELEV} ft`,
                    "Est. Drainage Speed": getDecayConstantGrade(selectedFeatureData.DECAY_CONSTANT_ESTIMATE),
                }
            });
        } else if (selectedFeatureData.RIMELEV) {
            setRelevantData({
                "type": "Outfall",
                "name": selectedFeatureData.NAME,
                "params": {
                    "Rim Elevation": `${selectedFeatureData.RIMELEV} ft`,
                    "Description": selectedFeatureData.DESCRIPT,
                }
            }); 
        }
    }, [selectedFeatureData]);

    return (
        <Box sx={{width: "300px", margin: "auto", display: "flex", flexDirection: "column", marginBottom: "10px"}}>
            {Object.entries(relevantData.params).map(([key, value]) => (
              <>
                  <div key={key} style={{display: "flex", justifyContent: "space-between"}}>
                      <strong>{key}:</strong> {value}
                  </div>
                  <hr style={{margin: "2px", color: "#000000", border: "none"}}/>
              </>

            ))}
        </Box>
    );
}

export default DataSnackbar;
